import { render, staticRenderFns } from "./announcements-table.vue?vue&type=template&id=78edd6d3&"
import script from "./announcements-table.vue?vue&type=script&lang=js&"
export * from "./announcements-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports